import clsx from "clsx"

export type NpSpinnerProps = {
  className?: string
}

export const NpSpinner = ({ className }: NpSpinnerProps) => {
  return (
    <div className={clsx(className, "animate-[spin_700ms_linear_infinite]", !className?.includes("size-") && "size-8")}>
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-full rotate-y-180">
        <title>Wird geladen...</title>
        <g clipPath="url(#paint0_angular_433_8048_clip_path)">
          <g transform="matrix(0 0.016 -0.016 0 16 16)">
            <foreignObject x={-1250} y={-1250} width={2500} height={2500}>
              <div
                style={{
                  background: "conic-gradient(from 90deg, currentColor 0deg, #0000 360deg)",
                  height: "100%",
                  width: "100%",
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d="M18.6668 29.3332C18.6668 30.8059 17.4729 31.9998 16.0002 31.9998C14.5274 31.9998 13.3335 30.8059 13.3335 29.3332C13.3335 27.8604 14.5274 26.6665 16.0002 26.6665C17.4729 26.6665 18.6668 27.8604 18.6668 29.3332Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0002 30.6665C16.7365 30.6665 17.3335 30.0696 17.3335 29.3332C17.3335 28.5968 16.7365 27.9998 16.0002 27.9998C15.2638 27.9998 14.6668 28.5968 14.6668 29.3332C14.6668 30.0696 15.2638 30.6665 16.0002 30.6665ZM16.0002 31.9998C17.4729 31.9998 18.6668 30.8059 18.6668 29.3332C18.6668 27.8604 17.4729 26.6665 16.0002 26.6665C14.5274 26.6665 13.3335 27.8604 13.3335 29.3332C13.3335 30.8059 14.5274 31.9998 16.0002 31.9998Z"
        />
        <defs>
          <clipPath id="paint0_angular_433_8048_clip_path">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 26.6667C21.891 26.6667 26.6667 21.891 26.6667 16C26.6667 10.109 21.891 5.33333 16 5.33333C10.109 5.33333 5.33333 10.109 5.33333 16C5.33333 21.891 10.109 26.6667 16 26.6667ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
